<template>
  <div class="calico-selected-business">
    <div class="top">
      <CalicoChip text="Your Business" />
      <button
        class="button-tertiary--small label--small"
        @click="$emit('change')"
      >
        <i class="bi bi-pencil-fill" />
        Change
      </button>
    </div>
    <CalicoBusinessCard
      :value="business.name"
      :title="business.name"
      :description="business.description"
      :city="business.city"
      :phone-number="business.phone"
      :state="business.state"
      :address="business.street"
      :zip="business.zip"
      :non-operating="business.nonOperating"
      :non-operating-text="business.nonOperatingText"
      :image="business.placesData?.business_photo?.photoUri"
    />
  </div>
</template>

<script>
import CalicoChip from '@/components/calico/chip/index.vue'
import CalicoBusinessCard from '@/components/calico/businessCard/index.vue'

export default {
  name: 'PatternSelectedBusiness',
  components: {
    CalicoChip,
    CalicoBusinessCard,
  },
  props: {
    business: {
      type: Object,
      required: true,
      default: () => ({})
    }
  }
}
</script>

<style lang="scss" scoped>
.calico-selected-business {
  @include stack-space($space-medium);
  .top {
    @include inline-space($space-medium);
    align-items: center;
    width: fit-content;
  }
}
</style>
